import { combineReducers } from 'redux';
import { layers } from './layersReducer';
import { view } from './viewReducer';
import { interaction } from './interactionReducer';
import { zoomLevelShortcuts } from './zoomLevelShortcuts';
export const mapCore = combineReducers({
    view,
    layers,
    interaction,
    zoomLevelShortcuts,
});
//# sourceMappingURL=reducer.js.map